module.exports = __webpack_public_path__ + "static/media/tezexFlow.40883c22.svg";